mutation deleteCompanyImage($input: DeleteCompanyImageInput!) {
  deleteCompanyImage(input: $input)
}
